import Cookies from 'js-cookie';

const options = {
    secure: true,
};

export class CookieStorage {
    setItem = (key: string, value: string | Record<string, unknown>) => {
        return Cookies.set(key, typeof value === 'object' ? JSON.stringify(value) : value, options);
    };

    getItem = (key: string) => {
        const value = Cookies.get(key);
        try {
            return value ? JSON.parse(value) : null;
        } catch {
            return value;
        }
    };

    key = (index: number) => {
        const allKeys = Object.keys(Cookies.get() || {});
        return index > -1 && index < allKeys.length ? allKeys[index] : '';
    };
}
